import { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

// sibling to the #root element on the actual html dom
const alertRoot = document.getElementById('alert-portal');

class AlertPortal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }

  componentDidMount() {
    alertRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    alertRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(
      this.props.children,
      this.el,
    );
  }
}

AlertPortal.propTypes = {
  children: PropTypes.node,
};

export {
  AlertPortal,
};
